export const EDITOR_MANAGING_SERVICE_INDICATORS_OPTIONS = [
  "Code",
  "generalName",
  "ComplianceIndicatorId",
  "FactIndicatorId",
  "CertificationDateIndicatorId",
  "FactContractIndicatorId",
  "ActualFrom",
];

export const EDITOR_MANAGING_SERVICE_INDICATORS_PERIOD_OPTIONS = [
  "ComplianceIndicatorId",
  "FactIndicatorId",
  "CertificationDateIndicatorId",
  "FactContractIndicatorId",
];

export const FACTORY_OPTION: string[] = [
  "services",
  "places",
  "placePosts",
  "warehouses",
  "tools",
  "requiredTools",
  "personal",
  "toolsInsurance",
  "toolsMetrological",
  "notes",
  "tradePremises",
];

export const EDITOR_SELECT_INDICATORS_PERIOD_OPTIONS = FACTORY_OPTION;

export const ZD_SELECT_BY_PERMISSIONS = {
  services: "zd.servicesEdit",
  places: "zd.placesEdit",
  placePosts: "zd.placePostEdit",
  warehouses: "zd.warehousesEdit",
  tools: "zd.toolsEdit",
  requiredTools: "zd.requiredToolsEdit",
  personal: "zd.personalEdit",
  toolsInsurance: "zd.toolsInsuranceEdit",
  toolsMetrological: "zd.toolsMetrologicalEdit",
  notes: "zd.notesEdit",
  tradePremises: "zd.tradePremisesEdit",
};
export const ZD_CHECK__BY_PERMISSIONS = {
  services: "zd.servicesCheck",
  places: "zd.placesCheck",
  placePosts: "zd.placePostCheck",
  warehouses: "zd.warehousesCheck",
  tools: "zd.toolsCheck",
  requiredTools: "zd.requiredToolsCheck",
  personal: "zd.personalCheck",
  toolsInsurance: "zd.toolsInsuranceCheck",
  toolsMetrological: "zd.toolsMetrologicalCheck",
  notes: "zd.notesCheck",
  tradePremises: "zd.tradePremisesCheck",
};

export const ZD_CHECK_PERMISSIONS = [
  "zd.personalCheck",
  "zd.tradePremisesCheck",
  "zd.toolsCheck",
  "zd.warehousesCheck",
  "zd.placePostCheck",
  "zd.placesCheck",
  "zd.servicesCheck",
  "zd.requiredToolsCheck",
  "zd.notesCheck",
  "zd.toolsInsuranceCheck",
  "zd.toolsMetrologicalCheck",
] as const;

export const getZDUserAccess = (
  hasPermission: (p: string) => boolean,
  selected: string,
  dealerChoice?: string,
) => {
  const editPermission = ZD_SELECT_BY_PERMISSIONS[selected];
  const checkPermission = ZD_CHECK__BY_PERMISSIONS[selected];
  // Когда selected пустой (план-отчёт) — проверяем zd.planReports.set
  const hasEdit = editPermission
    ? hasPermission(editPermission) && hasPermission("zd.planReports.set")
    : false;

  const hasAnyCheck = checkPermission
    ? hasPermission(checkPermission) && hasPermission("zd.planReports.set")
    : false;

  const hasAllCheck = ZD_CHECK_PERMISSIONS.every((perm) => hasPermission(perm));

  const isDealer =
    dealerChoice === "one" || (dealerChoice === "multiple" && !hasAnyCheck);

  return {
    hasEdit,
    hasAnyCheck,
    hasAllCheck,
    isDealer,
  };
};
